import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { selfTestApi } from '../../services/admin/selfTestApi'

const errMessage = (error: any, fallback: string) =>
  error?.response?.data?.error?.message || error?.message || fallback

/**
 * A mutation rather than a query: the run is explicit, never polled, and fires
 * ~70 loopback requests at the API. The last report lives in `mutation.data`,
 * so the section needs no local state of its own.
 */
export const useRunSelfTest = () =>
  useMutation({
    mutationFn: (refresh?: boolean) => selfTestApi.run(refresh),
    onSuccess: (report) => {
      if (report.totals.fail > 0) {
        toast.error(
          `${report.totals.fail} endpoint${report.totals.fail === 1 ? '' : 's'} failing`
        )
      } else {
        toast.success(`All ${report.totals.pass} probed endpoints healthy`)
      }
    },
    onError: (error: any) => toast.error(errMessage(error, 'Self-test failed to run')),
  })

/** Re-run one endpoint; returns just the rows that matched the filter. */
export const useRerunEndpoint = () =>
  useMutation({
    mutationFn: (path: string) => selfTestApi.runOne(path),
    onError: (error: any) => toast.error(errMessage(error, 'Could not re-run that endpoint')),
  })
